import { Socket } from "socket.io-client";

function socketEmit<Payload, Response>(
  socket: Socket,
  event: string,
  payload: Payload,
): Promise<{ response?: Response; error?: string }> {
  return new Promise((resolve) => {
    socket
      .timeout(5000)
      .emit(
        event,
        payload,
        (err: string, response: { response?: Response; error?: string }) => {
          if (err) {
            console.log("timeout");
            resolve({ error: "Timeout" });
          } else {
            resolve(response);
          }
        },
      );
  });
}

export default socketEmit;
